@if (patchingItemTreeForm !== null && patchingItemForm!== null && replacingItem !== null) {
  <h3 mat-dialog-title i18n>Editing {{ replacingItem.name }}</h3>
  <mat-dialog-content>
    <form>
      @if (patchingItemForm.get('name')) {
        <eas-editor-booking-item-name-form
          [parentFormGroup]="patchingItemForm"
          [itemNameForm]="getPatchingItemFormControl('name')">
        </eas-editor-booking-item-name-form>
      }
      @if (patchingItemTreeForm.get('bookingType')) {
        <eas-editor-booking-item-tree-booking-type-form
          [parentFormGroup]="patchingItemTreeForm"
          [itemTreeBookingTypeForm]="getPatchingItemTreeFormControl('bookingType')">
        </eas-editor-booking-item-tree-booking-type-form>
      }
      @if (patchingItemTreeForm.get('examType')) {
        <eas-editor-booking-item-tree-exam-type-form
          [parentFormGroup]="patchingItemTreeForm"
          [itemTreeExamTypeForm]="getPatchingItemTreeFormControl('examType')">
        </eas-editor-booking-item-tree-exam-type-form>
      }
      @if (patchingItemForm.get('canBeBooked') && patchingItemForm.get('hideSpecificBookingSettings')) {
        <eas-editor-booking-item-booking-form
          [parentFormGroup]="patchingItemForm"
          [replacingItem]="replacingItem"
          [itemCanBeBookedForm]="getPatchingItemFormControl('canBeBooked')"
          [itemHideSpecificBookingSettingsForm]="getPatchingItemFormControl('hideSpecificBookingSettings')">
        </eas-editor-booking-item-booking-form>
      }
      @if (getPatchingItemFormArray('settings')) {
        <ng-container [formGroup]="patchingItemForm">
          <ng-container formGroupName="settings">
            @for (itemSetting of patchingItem.settings; track itemSetting; let itemSettingIndex = $index) {
              <eas-editor-booking-item-setting-form
                [itemSetting]="itemSetting"
                [parentItemSetting]="null"
                [itemSettingForm]="getPatchingItemFormArrayFormGroup('settings', itemSettingIndex)">
              </eas-editor-booking-item-setting-form>
            }
          </ng-container>
        </ng-container>
      }
      @if (patchingItemTreeForm.get('extraRoles')) {
        <eas-editor-booking-item-tree-extra-roles-form
          [parentFormGroup]="patchingItemTreeForm"
          [itemTreeExtraRolesForm]="getPatchingItemTreeFormControl('extraRoles')">
        </eas-editor-booking-item-tree-extra-roles-form>
      }
      @if (getPatchingItemFormArray('metadataList')) {
        <eas-editor-booking-item-metadata-list-form
          [parentFormGroup]="patchingItemForm"
          [itemMetadataList]="patchingItem.metadataList"
          [parentItemMetadataList]="null"
          [itemMetadataListFormArray]="getPatchingItemFormArray('metadataList')"
          [newItemMetadataListFormArray]="getPatchingItemFormArray('newMetadataList')">
        </eas-editor-booking-item-metadata-list-form>
      }
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" i18n>Discard</button>
    <button mat-flat-button color="primary" [disabled]="patchingItemForm.invalid || patchingItemForm.invalid" (click)="onSubmit()" i18n>Apply</button>
  </mat-dialog-actions>
}
